import config from '@/config'

function listenerOnClickInProject () {
  window.addEventListener('click', hideListProject)
}

function hideListProject () {
  window.top?.postMessage('Cierre de panel de proyectos', getUrlFromPlatform())
}

function getUrlFromPlatform () {
  const URL = config.apiPlatformUrl
  const URLCut = 8
  return URL.slice(0, -URLCut)
}

const events = {
  listenerOnClickInProject
}

export default events
